import { useTranslation } from "react-i18next";
import { Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import styles from "./styles.module.css";

const Privacy = () => {
  const { t } = useTranslation();

  const policySections = t("privacyPolicy.sections", { returnObjects: true });

  return (
    <>
      <Page
        showFooter
        //   customPageClassName={styles.Container}
        customHeader={<HeaderBack title="Privacy" />}
        hasFloat={false}
      >
        <h1 className={styles.title}>{t("privacyPolicy.title")}</h1>
        <p className={styles.desc}>{t("privacyPolicy.description")}</p>
        <hr />

        <div className={styles.privacyContainer}>
          <ul className={styles.mainList}>
            {policySections.map((section) => (
              <li key={section.id}>
                <h3>{section.title}</h3>
                {/* Some sections only have a description, some have points, etc. */}
                {section.description && <p>{section.description}</p>}

                {/* Render bullet points if they exist */}
                {section.points && (
                  <ul className={styles.subList}>
                    {section.points.map((point, index) => (
                      // Using dangerouslySetInnerHTML to render the <strong> tags from the JSON
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: point }}
                      />
                    ))}
                  </ul>
                )}

                {/* Render contact info if it exists */}
                {section.contactInfo && (
                  <div className={styles.contactInfo}>
                    <strong>{section.contactInfo.team}</strong>
                    <span>{section.contactInfo.email}</span>
                    <span>{section.contactInfo.website}</span>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Page>
    </>
  );
};

export default Privacy;
